import { Facebook, Instagram, Linkedin, Music2, Youtube } from "lucide-react";

const TILES = {
  tiktok: { bg: "#000000", fg: "#ffffff", Icon: Music2 },
  reels: { bg: "linear-gradient(135deg,#f58529,#dd2a7b 55%,#8134af)", fg: "#ffffff", Icon: Instagram },
  shorts: { bg: "#ff0000", fg: "#ffffff", Icon: Youtube },
  x: { bg: "#000000", fg: "#ffffff", Icon: null },
  linkedin: { bg: "#0a66c2", fg: "#ffffff", Icon: Linkedin },
  facebook: { bg: "#1877f2", fg: "#ffffff", Icon: Facebook },
};

export const PlatformTile = ({ id, size = 30 }) => {
  const t = TILES[id] || { bg: "#333", fg: "#fff", Icon: null };
  return (
    <span className="shrink-0 grid place-items-center rounded-lg font-display font-bold" style={{ width: size, height: size, background: t.bg, color: t.fg, fontSize: size * 0.5 }} aria-hidden>
      {t.Icon ? <t.Icon size={size * 0.55} /> : "X"}
    </span>
  );
};
